import { useState, useCallback } from 'react';
import usePfqAxios from './usePfqAxios';
import Constants from '../Constants';
import { toaster } from '../utils/toast';
import AppConfig from '../AppConfig';
import { REQUEST_TYPES } from '@demandproai/shared';

const useCertifiedLifecarePlan = ({ caseId }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { postData: postPfqData } = usePfqAxios();

    const openModal = useCallback(() => setIsModalOpen(true), []);
    const closeModal = useCallback(() => setIsModalOpen(false), []);

    const submitLifecarePlan = useCallback(async () => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        try {
            const pfqResponse = await postPfqData(Constants.ApiUrl.createRequest, JSON.stringify({
                caseId,
                requestType: REQUEST_TYPES.CERTIFIED_LIFECARE_ASSIGNMENT
            }));
            if (pfqResponse?.success) {
                toaster({ message: 'Lifecare Plan request submitted.', success: true });
            } else {
                toaster({ message: pfqResponse?.message || 'Failed to submit', success: false });
            }
            closeModal();
        } finally {
            setIsSubmitting(false);
        }
    }, [caseId, postPfqData, closeModal, isSubmitting]);

    const isVisible = String(AppConfig.CertifiedLifecareEnabled).trim().toLowerCase() === 'true';
    return { isModalOpen, isLoading: isSubmitting, openModal, closeModal, submitLifecarePlan, isVisible };
};

export default useCertifiedLifecarePlan;
